import { getCompanyDefaultLanguage, getCurrentLanguage } from '~/localization';

export const APIs = {
  enum: {
    listValuesByGroup: (
      group: string,
      companyDefaultLanguage = getCompanyDefaultLanguage(),
    ) => `/json/enum/${group}/${companyDefaultLanguage}?includeInactive=false`,
    translation: (group: string, code: string) =>
      `/json/enum/${group}/v/${code}/loc`,
    details: (group: string, code: string) =>
      `/json/enum/${group}/v/${code}/details`,
    add: (group: string) => `/json/enum/${group}/v`,
    get: (group: string, name: string) => `/json/enum/${group}/d/${name}`,
    update: (group: string, code: string) => `/json/enum/${group}/v/${code}/`,
    groupCodes: (
      group: string,
      companyDefaultLanguage = getCompanyDefaultLanguage(),
    ) => `/json/enum/${group}/${companyDefaultLanguage}?includeInactive=false`,
    group: (group: string) => `/json/enum/${group}/v`,
    groupCode: (group: string, code: string) => `/json/enum/${group}/v/${code}`,
    groupTags: (group: string) => `/json/enum/${group}/tag`,
    all: (currentLanguage = getCurrentLanguage()) =>
      `/json/enum/ALL/${currentLanguage}`,
    allWithConfig: '/json/enum?format=all',
    order: (group: string) => `/json/enum/${group}/order`,
    currentVersion: '/json/enum/currentVersion',
    customFieldAttribute: (name: string) =>
      `/json/customdata/entity/${name}/attribute`,
    updateCustomFieldAttribute: (group: string, code: string) =>
      `/json/customdata/entity/${group}/attribute/${code}`,
    deleteCustomFieldAttribute: (group: string, code: string) =>
      `/json/customdata/entity/${group}/attribute/${code}/h`,
    customFields: (name: string, iEmpId: string) =>
      `/json/customdata/${name}/${iEmpId}`,
  },
  employee: {
    attachment: (empId: number, fileId: number) =>
      `/bin/employee/${empId}/file/${fileId}`,
    basic: (empId: string | number) => `/json/employee/${empId}/basic`,
    customData: (empId: string | number, lang: string) =>
      `/json/customdata/EMPLOYEE/${empId}?langIso=${lang}`,
    new: () => `/json/employee/new`,
    list: () => `/json/employee/full?format=SHORT`,
    employment: (empId: string | number) =>
      `/json/employee/${empId}/employment`,
    fullDetail: (empId: string | number) =>
      `/json/employee/${empId}/employment/current/full`,
    ssn: (ssn: string) => `/json/employee/ssn/${ssn}`,
    pendingList: () => `/json/employee/full/PENDING?format=short`,
  },
  forms: {
    createForm: () => '/forms/forms',
    getAllForms: () =>
      '/forms/forms?select=title,name,path,settings,properties',
    getBuilder: (
      type: 'basic' | 'full' | 'employment',
      language: string,
      noPrefix?: boolean,
    ) =>
      `${!noPrefix ? '/forms' : ''}/builders/${type}/options?lang=${language}`,
    getFormsComponents: (formId: string) => `/forms/forms/${formId}/components`,
    getCustomPageFormsComponents: () => `/forms/forms/components/custompage`,
    formGeneral: (formId: string, noPrefix?: boolean) =>
      `${!noPrefix ? '/forms' : ''}/forms/${formId}`,
    formProvisionalEmpSubmission: (empNumber: string, noPrefix?: boolean) =>
      `${!noPrefix ? '/forms' : ''}/forms/submissions/${empNumber}`,
    formSubmissions: (formId: string, noPrefix?: boolean) =>
      `${!noPrefix ? '/forms' : ''}/forms/${formId}/submissions`,
    formOverlappingEmpSubmission: (formId: string, noPrefix?: boolean) =>
      `${!noPrefix ? '/forms' : ''}/forms/${formId}/submissions/overlapping`,
    formRehireEmpSubmission: (formId: string, noPrefix?: boolean) =>
      `${!noPrefix ? '/forms' : ''}/forms/${formId}/submissions/rehire`,
    formDefault: (type: 'basic' | 'full' | 'employment', noPrefix?: boolean) =>
      `${!noPrefix ? '/forms' : ''}/builder/${type}/form`,
    translations: (formId: string) => `/forms/forms/${formId}/i18n`,
    getLatestVersion: () => '/forms/forms/version/latest',
    updateVersion: (formId: string) => `/forms/forms/${formId}/latest`,
  },
};
